var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: { "value-key": "key" },
          on: { change: _vm.updateNewVendor },
          model: {
            value: _vm.vendorId,
            callback: function ($$v) {
              _vm.vendorId = $$v
            },
            expression: "vendorId",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c(
            "el-option",
            {
              key: item.vendor.vendorId,
              attrs: {
                label: item.vendor.firstName + " " + item.vendor.lastName,
                value: item.vendor.vendorId,
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(item.vendor.firstName) +
                  " " +
                  _vm._s(item.vendor.lastName) +
                  " (" +
                  _vm._s(_vm._f("distance")(item.distance)) +
                  " miles) "
              ),
            ]
          )
        }),
        1
      ),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: {
            disabled: _vm.options.length < 1 || _vm.disableCTA,
            type: "success",
          },
          on: { click: _vm.handleAssignVendor },
        },
        [_vm._v(" Assign Vendor ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }